module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.srcs) ? _c('div', {
    staticClass: "slideshow-background"
  }, _vm._l((_vm.srcs), function(url, index) {
    return _c('div', {
      style: ('background-image:url(' + url + ')'),
      attrs: {
        "data-visible": _vm.current === index
      }
    })
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fb05960"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SlideshowBackground.vue
// module id = 381
// module chunks = 1